import { initializeUnauthedFeatureFlags } from './unauthedFeatureFlag.service';

import { uuidGen } from '@/utils/utils';

const UNAUTHED_UUID_KEY = 'unauthed_uuid';

const getUnauthedUuid = (): string => {
  if (!localStorage.getItem(UNAUTHED_UUID_KEY)) {
    localStorage.setItem(UNAUTHED_UUID_KEY, uuidGen());
  }

  return localStorage.getItem(UNAUTHED_UUID_KEY) as string;
};

export const initUnauthedUserSession = () => {
  const unauthedUuid = getUnauthedUuid();
  // No Segment track here: this runs at boot, before auth, so the event would
  // carry an anonymousId and no userId and bill as an anonymous MTU. The uuid
  // was only ever a property on that event, never a Segment identity.
  initializeUnauthedFeatureFlags(unauthedUuid);
};
